import { combineReducers } from "redux";
// import welcomes from "../features/admin/aboutus/welcomes/Slice";
import color_prediction from "../features/games/color_prediction/Slice";
import toss_karo from "../features/games/toss_karo/Slice";

const games = combineReducers({
  color_prediction: color_prediction,
  toss_karo: toss_karo,
});

export default games;
